import { ofType } from 'redux-observable';
import { EMPTY, of } from 'rxjs';
import { mergeMap, withLatestFrom } from 'rxjs/operators';
import { selectEssentialsFormQuoteId } from 'state/essential/infos/selectors';
import { commonQuoteAction } from 'state/forms/actions/quote';
import { selectQuoteResult } from 'state/quotes/results/results.selectors';
import type { EpicWithThunk } from 'state/state.common';

export function removeEssentialQuote(): EpicWithThunk {
  return (action$, state$) => {
    return action$.pipe(
      ofType('FORM_INPUT_DATA_CHANGED', 'FORM_ENRICHMENT_REQUESTED'),
      withLatestFrom(state$),
      mergeMap(([action, state]) => {
        const quoteId = selectEssentialsFormQuoteId(state, action.tabId);
        if (!quoteId) {
          return EMPTY;
        }
        const quoteResult = selectQuoteResult(state, quoteId);

        const isQuoteFailedOrRejected = quoteResult?.status === 'Failed' || quoteResult?.status === 'Rejected';

        return isQuoteFailedOrRejected
          ? of(commonQuoteAction.quoteRemoved('essential', action.tabId, quoteId))
          : of(commonQuoteAction.quoteStale('essential', action.tabId, quoteId, true));
      }),
    );
  };
}
